import React, { Component, useEffect, useState } from 'react';
import configData from '../configData.json';
import Spinner from 'react-bootstrap/Spinner';
import SelectSearch, { fuzzySearch } from "react-select-search";
import moment from 'moment';

import "../style/select-search.css";

export default function ImplementSetupRightFilterContent(props) {

    const [toDate, setToDate] = useState(new Date());
    const [fromDate, setFromDate] = useState(new Date(toDate.getFullYear(), 0, 1, 23, 59, 59));

    const [owners, setOwners] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [locationType, setLocationType] = useState([{ value: "0", name: "-- Select A Value --" }]);
    const [locationName, setLocationName] = useState([{ value: "0", name: "-- Select A Value --" }]);
    const [serviceType, setServiceType] = useState([{ value: "0", name: "-- Select A Value --" }]);
    const [fundingType, setFundingType] = useState([{ value: "0", name: "-- Select A Value --" }]);
    const [contractCompleted, setContractCompleted] = useState([{ value: "0", name: "-- Select A Value --" }]);
    const [serviceRegion, setServiceRegion] = useState([{ value: "0", name: "-- Select A Value --" }]);
    const [implementationStatusOptions, setImplementationStatusOptions] = useState([{ value: "0", name: "-- Select A Value --" }]);
    const [selectedOwner, setSelectedOwner] = useState(-1);
    const [selectedCust, setSelectedCust] = useState(-1);
    const [selectedLocationType, setSelectedLocationType] = useState(0);
    const [selectedLocationName, setSelectedLocationName] = useState(0);
    const [selectedServiceType, setSelectedServiceType] = useState(0);
    const [selectedFundingType, setSelectedFundingType] = useState(0);
    const [selectedContractCompleted, setSelectedContractCompleted] = useState(0);
    const [selectedServiceRegion, setSelectedServiceRegion] = useState(0);
    const [selectedImplementationStatus, setSelectedImplementationStatus] = useState(0);

    const [ownerLoading, isOwnerLoading] = useState(false);
    const [customerLoading, isCustomerLoading] = useState(false);
    const [divisionLoading, isDivisionLoading] = useState(false);


    const LoadOwners = async () => {
        debugger;
        isOwnerLoading(true);
        const ownerUrl = `${configData.BASE_APP_URL}Owner/GetOwnerList`;
        await fetch(ownerUrl,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            }
        ).then(resp => resp.json())
            .then(resp => {
                let ownerOptions = [];
                resp.map(owner => {
                    const cust = {
                        "name": owner.ownerName,
                        "value": owner.ownerID
                    }
                    ownerOptions = [...ownerOptions, cust];
                })
                const defaultOwner = {
                    "name": "-- ALL OWNERS --",
                    "value": -1
                }
                ownerOptions.unshift(defaultOwner);
                setOwners(ownerOptions)
            })
        isOwnerLoading(false);
        LoadCustomer(-1);
        // setIsDisabled(props.isDisabled);
    }

    const LoadCustomer = async (ownerKey) => {
        debugger;
        isCustomerLoading(true);
        const custUrl = `${configData.BASE_APP_URL}Customer/GetCustomerList/${ownerKey}`;
        await fetch(custUrl,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            }
        ).then(resp => resp.json())
            .then(resp => {
                let customerOptions = [];
                resp.map(customer => {
                    const cust = {
                        "name": customer.customerName,
                        "value": customer.customerKey
                    }
                    customerOptions = [...customerOptions, cust];
                })
                const defaultCustomer = {
                    "name": "-- ALL CUSTOMERS --",
                    "value": -1
                }
                customerOptions.unshift(defaultCustomer);
                setCustomers(customerOptions)
            })
        isCustomerLoading(false);
        // setIsDisabled(props.isDisabled);
        LoadLocationType();
    }

    const LoadLocationType = async () => {
        debugger;
        isDivisionLoading(true);
        const URL = `${configData.BASE_APP_URL}Implementaion/GetLocationType`;

        try {
            const response = await fetch(URL, {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            });

            const data = await response.json();

            let locationTypeOptions = [];

            data.forEach((locationType) => {
                const loctype = {
                    "name": locationType.codeDesc,
                    "value": locationType.codeID
                };
                locationTypeOptions.push(loctype);
            });

            const allLocType = {
                "name": "-- ALL LOCATION TYPE --",
                "value": -1
            };

            locationTypeOptions.unshift(allLocType);

            const defaultLocType = {
                "name": "-- Select A Value --",
                "value": 0
            };

            locationTypeOptions.unshift(defaultLocType);
            setLocationType(locationTypeOptions);
            LoadLocationName(selectedCust, 0)
        } catch (error) {
            console.error('Error loading location types:', error);
        } finally {
            isDivisionLoading(false);
        }

    };

    const LoadLocationName = async (custkey, locTypeCode) => {
        debugger;
        isDivisionLoading(true);


        const URL = `${configData.BASE_APP_URL}Implementaion/GetLocationName/${custkey}/${locTypeCode}`;

        try {
            let locationNameOptions = [];
            if (["DIV", "REG", "BRA"].includes(locTypeCode)) {
                const response = await fetch(URL, {
                    method: 'GET',
                    headers: {
                        'Content-type': 'application/json',
                        'Authorization': sessionStorage.getItem('my-token')
                    }
                });

                const data = await response.json();

                data.forEach((locationName) => {
                    const locname = {
                        "name": locationName.value,
                        "value": locationName.key
                    };
                    locationNameOptions.push(locname);
                });
            }

            const allLocName = {
                "name": "-- ALL LOCATION NAME --",
                "value": -1
            };

            locationNameOptions.unshift(allLocName);

            const defaultLocName = {
                "name": "-- Select A Value --",
                "value": 0
            };

            locationNameOptions.unshift(defaultLocName);
            setLocationName(locationNameOptions);
        } catch (error) {
            console.error('Error loading location names:', error);
        } finally {
            isDivisionLoading(false);
        }
    };

    const LoadTypeOfService = async () => {
        debugger;
        isDivisionLoading(true);
        const URL = `${configData.BASE_APP_URL}Implementaion/GetTypeOfService`;
        await fetch(URL,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            })
            .then(resp => resp.json())
            .then(resp => {
                let typeOfServiceOptions = [];
                resp.map((typeOfService) => {
                    const sertype = {
                        "name": typeOfService.codeDesc,
                        "value": typeOfService.codeID
                    }
                    typeOfServiceOptions = [...typeOfServiceOptions, sertype];

                })
                const defaultLocType = {
                    "name": "-- Select A Value --",
                    "value": 0
                }
                typeOfServiceOptions.unshift(defaultLocType);
                setServiceType(typeOfServiceOptions)
            })
        isDivisionLoading(false);
    }

    const LoadFundingType = async () => {
        debugger;
        isDivisionLoading(true);
        const URL = `${configData.BASE_APP_URL}Implementaion/GetFundingType`;

        try {
            const response = await fetch(URL, {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            });

            const data = await response.json();

            let fundingTypeOptions = [];

            data.forEach((fundingType) => {
                const fundtype = {
                    "name": fundingType.codeDesc,
                    "value": fundingType.codeID
                };
                fundingTypeOptions.push(fundtype);
            });

            const allFundType = {
                "name": "ALL",
                "value": -1
            };

            fundingTypeOptions.unshift(allFundType);

            const defaultFundType = {
                "name": "-- Select A Value --",
                "value": 0
            };

            fundingTypeOptions.unshift(defaultFundType);
            setFundingType(fundingTypeOptions);
        } catch (error) {
            console.error('Error loading funding types:', error);
        } finally {
            isDivisionLoading(false);
        }
    };

    const LoadContractCompleted = async () => {
        debugger;
        isDivisionLoading(true);
        const URL = `${configData.BASE_APP_URL}Implementaion/GetContractCompleted`;

        try {
            const response = await fetch(URL, {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            });

            const data = await response.json();

            let contractCompletedOptions = [];

            data.forEach((contractCompleted) => {
                const contcomp = {
                    "name": contractCompleted.codeDesc,
                    "value": contractCompleted.codeID
                };
                contractCompletedOptions.push(contcomp);
            });

            const allContractCompleted = {
                "name": "ALL",
                "value": -1
            };

            contractCompletedOptions.unshift(allContractCompleted);

            const defaultContractCompleted = {
                "name": "-- Select A Value --",
                "value": 0
            };

            contractCompletedOptions.unshift(defaultContractCompleted);



            setContractCompleted(contractCompletedOptions);
        } catch (error) {
            console.error('Error loading contract completed options:', error);
        } finally {
            isDivisionLoading(false);
        }
    };

    const LoadServiceRegion = async () => {
        debugger;
        isDivisionLoading(true);
        const URL = `${configData.BASE_APP_URL}Implementaion/GetServiceRegion`;

        try {
            const response = await fetch(URL, {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            });

            const data = await response.json();

            let serviceRegionOptions = [];

            data.forEach((serviceRegion) => {
                const serreg = {
                    "name": serviceRegion.codeDesc,
                    "value": serviceRegion.codeID
                };
                serviceRegionOptions.push(serreg);
            });

            const allServiceRegion = {
                "name": "ALL",
                "value": -1
            };

            serviceRegionOptions.unshift(allServiceRegion);

            const defaultServiceRegion = {
                "name": "-- Select A Value --",
                "value": 0
            };

            serviceRegionOptions.unshift(defaultServiceRegion);
            setServiceRegion(serviceRegionOptions);
        } catch (error) {
            console.error('Error loading funding types:', error);
        } finally {
            isDivisionLoading(false);
        }
    };

    
    const LoadImplementationStatus = async () => {
        debugger;
        isDivisionLoading(true);
        const URL = `${configData.BASE_APP_URL}Implementaion/GetImplementationStatus`;

        try {
            const response = await fetch(URL, {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            });

            const data = await response.json();

            let statusOptions = [];

            data.forEach((implementationStatus) => {
                const impSts = {
                    "name": implementationStatus.codeDesc,
                    "value": implementationStatus.codeID
                };
                statusOptions.push(impSts);
            });

            const defaultImpStatus = {
                "name": "-- Select A Value --",
                "value": 0
            };

            statusOptions.unshift(defaultImpStatus);
            setImplementationStatusOptions(statusOptions);
        } catch (error) {
            console.error('Error loading Implemntation Status Options:', error);
        } finally {
            isDivisionLoading(false);
        }
    };



    const LoadBills = async (e) => {
        debugger;
        e.preventDefault();

        if (selectedLocationType === 0) {
            document.getElementById("locationtype-error").innerHTML = "Select a location type";
            return;
        }
        if (selectedLocationName === 0) {
            document.getElementById("locationname-error").innerHTML = "Select a location name";
            return;
        }
        if (selectedServiceType === 0) {
            document.getElementById("servicetype-error").innerHTML = "Select a service type";
            return;
        }
        if (selectedFundingType === 0) {
            document.getElementById("fundingtype-error").innerHTML = "Select a funding type";
            return;
        }
        if (selectedContractCompleted === 0) {
            document.getElementById("contractcompleted-error").innerHTML = "Select contract completed";
            return;
        }
        if (selectedServiceRegion === 0) {
            document.getElementById("region-error").innerHTML = "Select a region of nVision Service";
            return;
        }
        if (selectedImplementationStatus === 0) {
            document.getElementById("status-error").innerHTML = "Select a Implementation Status";
            return;
        }

        if (selectedServiceType === 'BTH') {
            props.onSearchClick(selectedOwner, selectedCust, selectedLocationType, selectedLocationName, -1, selectedFundingType, selectedContractCompleted, selectedServiceRegion, selectedImplementationStatus);
        } else {
            props.onSearchClick(selectedOwner, selectedCust, selectedLocationType, selectedLocationName, selectedServiceType, selectedFundingType, selectedContractCompleted, selectedServiceRegion, selectedImplementationStatus);
        }

    }

    useEffect(() => {
        debugger;
        LoadOwners();
        LoadTypeOfService();
        LoadFundingType();
        LoadContractCompleted();
        LoadServiceRegion();
        LoadImplementationStatus()
        // LoadCustomer();
    }, [])

    const onOwnerSelect = (e) => {
        // debugger;
        var ownerkey = e;

        LoadCustomer(e);
        setSelectedOwner(e);
        // LoadDivision(0)
        setSelectedCust(-1);
        // props.onCustomerChange(custkey);

    };

    const onCustomerSelect = (e) => {
        var custkey = e;
        LoadLocationType(e);
        setSelectedCust(e);
        setSelectedLocationType(0);
        setSelectedLocationName(0);

    };

    const onLocationTypeSelect = (e) => {
        var locTypeKey = e;
        if (locTypeKey != 0) {
            document.getElementById("locationtype-error").innerHTML = "";
        }

        setSelectedLocationType(e);
        LoadLocationName(selectedCust, e);
        if (e != 0) {
            setSelectedLocationName(-1);
        }
        else {
            setSelectedLocationName(0);
        }

    };

    const onLocationNameSelect = (e) => {
        debugger;
        var locNameKey = e;
        if (locNameKey != 0) {
            document.getElementById("locationname-error").innerHTML = "";
        }
        setSelectedLocationName(e);
    };

    const onServiceTypeSelect = (e) => {
        var serTypeKey = e;
        if (serTypeKey != 0) {
            document.getElementById("servicetype-error").innerHTML = "";
        }
        setSelectedServiceType(e);
    };

    const onFundingTypeSelect = (e) => {
        var fundTypeKey = e;
        if (fundTypeKey != 0) {
            document.getElementById("fundingtype-error").innerHTML = "";
        }
        setSelectedFundingType(e);
    };

    const onContractCompletedSelect = (e) => {
        var conCompKey = e;
        if (conCompKey != 0) {
            document.getElementById("contractcompleted-error").innerHTML = "";
        }
        setSelectedContractCompleted(e);
    };

    const onSericeRegionSelect = (e) => {
        var serRegionKey = e;
        if (serRegionKey != 0) {
            document.getElementById("region-error").innerHTML = "";
        }
        setSelectedServiceRegion(e);
    };

    const onStatusSelect = (e) => {
        let statusKey = e;
        if (statusKey !== 0) {
            document.getElementById("status-error").innerHTML = "";
        }
        setSelectedImplementationStatus(e);
    };

    const ClearFilter = async () => {  

        let customerOptions = [];
        const defaultCustomer = {
            "name": "-- ALL CUSTOMERS --",
            "value": -1
        }
        customerOptions.unshift(defaultCustomer);
        setCustomers(customerOptions);
        let locationNameOptions = [];
        const allLocName = {
            "name": "-- ALL LOCATION NAME --",
            "value": -1
        };

        locationNameOptions.unshift(allLocName);
        const defaultLocName = {
            "name": "-- Select A Value --",
            "value": 0
        };
        locationNameOptions.unshift(defaultLocName);
        setLocationName(locationNameOptions)

        setSelectedOwner(-1);
        setSelectedCust(-1);
        setSelectedLocationType(0);
        setSelectedLocationName(0);
        setSelectedServiceType(0);
        setSelectedFundingType(0);
        setSelectedContractCompleted(0);
        setSelectedServiceRegion(0);
        setSelectedImplementationStatus(0);

    }


    return (
        <>
            <div className="mb-2 form-field">
                <div id="owner-error" className="text-danger"></div>
                <label>Owner</label>
                <label id="owner-highlight" className="text-danger">*</label>
                <div>
                    <SelectSearch
                        id="ddnOwner"
                        name="ddnOwner"
                        value={selectedOwner}
                        options={owners}
                        onChange={onOwnerSelect}
                        search
                        filterOptions={fuzzySearch}

                    >
                    </SelectSearch>
                </div>
                {ownerLoading ? <Spinner className='spinner-border spinner-border-custom' animation="border" variant="primary" /> : ownerLoading}
            </div>
            <div className="mb-3 form-field">
                <div id="customer-error" className="text-danger"></div>
                <label>Customer</label>
                <label id="customer-highlight" className="text-danger">*</label>
                <div>
                    <SelectSearch
                        id="ddnCustomer"
                        name="ddnCustomer"
                        value={selectedCust}
                        options={customers}
                        onChange={onCustomerSelect}
                        search
                        filterOptions={fuzzySearch}

                    >
                    </SelectSearch>
                </div>
                {divisionLoading ? <Spinner className='spinner-border spinner-border-custom' animation="border" variant="primary" /> : divisionLoading}
            </div>
            <div className="mb-2 form-field">
                <div id="locationtype-error" className="text-danger"></div>
                <label>Location Type</label>
                <label id="location-type-highlight" className="text-danger">*</label>
                <div>
                    <SelectSearch
                        id="ddnLocType"
                        name="ddnLocType"
                        value={selectedLocationType}
                        options={locationType}
                        onChange={onLocationTypeSelect}
                        search
                        filterOptions={fuzzySearch}
                    >
                    </SelectSearch>
                </div>
            </div>
            <div className="mb-2 form-field">
                <div id="locationname-error" className="text-danger"></div>
                <label>Location Name</label>
                <label id="location-name-highlight" className="text-danger">*</label>
                <div>
                    <SelectSearch
                        id="ddnLocName"
                        name="ddnLocName"
                        value={selectedLocationName}
                        options={locationName}
                        onChange={onLocationNameSelect}
                        search
                        filterOptions={fuzzySearch}
                    >
                    </SelectSearch>
                </div>
            </div>
            <div className="mb-2 form-field">
                <div id="servicetype-error" className="text-danger"></div>
                <label>Type of service</label>
                <label id="typeofservice-highlight" className="text-danger">*</label>
                <div>
                    <SelectSearch
                        id="ddnServiceType"
                        name="ddnServiceType"
                        value={selectedServiceType}
                        options={serviceType}
                        onChange={onServiceTypeSelect}
                        search
                        filterOptions={fuzzySearch}
                    >
                    </SelectSearch>
                </div>
            </div>
            <div className="mb-2 form-field">
                <div id="fundingtype-error" className="text-danger"></div>
                <label>Funding Type</label>
                <label id="funding-type-highlight" className="text-danger">*</label>
                <div>
                    <SelectSearch
                        id="ddnFundingType"
                        name="ddnFundingType"
                        value={selectedFundingType}
                        options={fundingType}
                        onChange={onFundingTypeSelect}
                        search
                        filterOptions={fuzzySearch}
                    >
                    </SelectSearch>
                </div>
            </div>
            <div className="mb-2 form-field">
                <div id="contractcompleted-error" className="text-danger"></div>
                <label>Contract Completed</label>
                <label id="contract-completed-highlight" className="text-danger">*</label>
                <div>
                    <SelectSearch
                        id="ddnContractCompleted"
                        name="ddnContractCompleted"
                        value={selectedContractCompleted}
                        options={contractCompleted}
                        onChange={onContractCompletedSelect}
                        search
                        filterOptions={fuzzySearch}
                    >
                    </SelectSearch>
                </div>
            </div>
            <div className="mb-2 form-field">
                <div id="region-error" className="text-danger"></div>
                <label>Region of nVision Service</label>
                <label id="region-highlight" className="text-danger">*</label>
                <div>
                    <SelectSearch
                        id="ddnRegion"
                        name="ddnRegion"
                        value={selectedServiceRegion}
                        options={serviceRegion}
                        onChange={onSericeRegionSelect}
                        search
                        filterOptions={fuzzySearch}
                    >
                    </SelectSearch>
                </div>
            </div>
            <div className="mb-2 form-field">
                <div id="status-error" className="text-danger"></div>
                <label>Implementation Status</label>
                <label id="region-highlight" className="text-danger">*</label>
                <div>
                    <SelectSearch
                        id="ddnImplement"
                        name="ddnImplement"
                        value={selectedImplementationStatus}
                        options={implementationStatusOptions}
                        onChange={onStatusSelect}
                        search
                        filterOptions={fuzzySearch}
                    >
                    </SelectSearch>
                </div>
            </div>
            <div className="form-field mx-auto" style={{ width: "180px" }}>
                <button type="button" onClick={ClearFilter} className='btn btn-clear'>Clear</button>
                <button type="button" onClick={LoadBills} className='btn btn-filter ms-2'>Filter</button>
            </div>
        </>
    )
}
